module.exports = __webpack_public_path__ + "static/media/logo.cdf410e3.png";